// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__OjkWL","title":"style_title__IwNgy","answerItem":"style_answerItem__DcfXt","active":"style_active__0Xybe","input":"style_input__rAYJJ"};